import template from "./html-custom-btn-preview.html";
import {htmlCustomBtnPreviewController} from "./html-custom-btn-preview.controller";
import "./html-custom-btn-preview.scss";

export const htmlCustomBtnPreviewComponent = {
    template,
    controller: htmlCustomBtnPreviewController,
    controllerAs: "preview",
    bindings: {
        screen: "@",
        prWidth: "@",
        prHeight: "@",
        index: "@",
        background: "@",
        videoBackground: "@",
        videoOverlay: "@",
        areas: "@",
        mode: "@",
        gif: "@",
        strip: "@",
        ratio: "@",
        gifSpeed: "@",
        overlay: "@",
        videoTime: "<",
        videoSpeed: "<",
        animationSpeed: "@",
        printerBleed: "@",
        relatedValues: "@",
        ignoreOverflow: "<",
        hideOverlay: "<",
        hideTitle: "<",
        bgMode: "<",
        bgColor: "<",
        bgStyle: "<",
        backBtn: "<",
        sharingBackBtn: "<",
        captureBtn: "<",
        proceedBtn: "<",
        emailBtn: "<",
        smsBtn: "<",
        printBtn: "<",
        doneBtn: "<",
        qrCodeBtn: "<",
        singleBtn: "<",
        boomerangBtn: "<",
        gifBtn: "<",
        sceneBtn: "<",
        filterBtn: "<",
        scenePopupColor: "<",
        hideScene: "<",
        transparency: "<",
        scenes: "<",
        hidePhotoBg: "<",
        badgeActive: "<",
        displayPopup: "<",
        liveViewOpacity: "@",
        enabled: "<",
        margin: "<",
        isSingle: "<",
        isPortraite: "<",
        hideOutputPictureVideo: "<",
        hideSharingOptions: "<"
    }
};



// WEBPACK FOOTER //
// ./sources/components/common/html-custom-btn-preview/html-custom-btn-preview.component.js